import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'
import { useState } from "react";

const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    dob: Yup.string().required("Required"),
    fatherName: Yup.string().required("Required"),
    motherName: Yup.string().required("Required"),
    address1: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    state: Yup.string().required("Required"),
    zip: Yup.string()
        .required("ZIP code is required")
        .matches(/^[1-9][0-9]{5}$/, "ZIP code must be a valid 6-digit number"),
    country: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    confirmEmail: Yup.string().oneOf([Yup.ref("email"), null], "Emails must match").required("Required"),
    aadhar: Yup.string()
        .required("Aadhar number is required")
        .matches(/^[2-9]{1}[0-9]{11}$/, "Aadhar must be a 12-digit valid number"),
    mobile: Yup.string()
        .required("Mobile number is required")
        .matches(/^[6-9]{1}[0-9]{9}$/, "Mobile must be a valid 10-digit number"),
    board: Yup.string().required("Required"),
    passMonth: Yup.string().required("Required"),
    passYear: Yup.string().required("Required"),
    totalMarks: Yup.string().required("Required"),
    groupMarks: Yup.string().required("Required"),
    preferences: Yup.array().of(Yup.string().required("Required")),
    sponsorRelation: Yup.string().required("Required"),
    sponsorName: Yup.string().required("Required"),
    sponsorPlace: Yup.string().required("Required"),
    qualifyingExam: Yup.string().required("Required"),
    declaration: Yup.boolean().oneOf([true], "You must accept the declaration to submit the form").required("Required"),
    files: Yup.object().shape({
        photo: Yup.mixed().nullable(),
        ssc: Yup.mixed().nullable(),
        inter: Yup.mixed().nullable(),
        rankCard: Yup.mixed().nullable(),
        passport: Yup.mixed().nullable(),
        sponsorLetter: Yup.mixed().nullable(),
        addressProof: Yup.mixed().nullable(),
        signature: Yup.mixed().nullable(),
        parentsignature: Yup.mixed().nullable(),
    }),
});

const initialValues = {
    name: "",
    dob: "",
    fatherName: "",
    motherName: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    country: "India",
    email: "",
    confirmEmail: "",
    aadhar: "",
    mobile: "",
    board: "",
    passMonth: "",
    passYear: "",
    totalMarks: "",
    groupMarks: "",
    preferences: ["", "", "", "", ""],
    sponsorRelation: "",
    sponsorName: "",
    sponsorPlace: "",
    rank: "",
    qualifyingExam: "",

    submittedDate: new Date().toISOString().split("T")[0],
    files: {
        photo: null,
        ssc: null,
        inter: null,
        rankCard: null,
        passport: null,
        sponsorLetter: null,
        addressProof: null,
        signature: null,
        parentsignature: null,
    },
    status: "Pending",
    reason: "reason",
};

const BTechCategoryBFormNRI2026 = () => {

    const [fileNames, setFileNames] = useState({});
    const MAX_FILE_SIZE = 300 * 1024; // 300 KB

    const handleSubmit = async (values, { resetForm }) => {
        const formData = new FormData();

        const months = {
            "01": "January",
            "02": "February",
            "03": "March",
            "04": "April",
            "05": "May",
            "06": "June",
            "07": "July",
            "08": "August",
            "09": "September",
            "10": "October",
            "11": "November",
            "12": "December",
        };

        const submitValues = {
            ...values,
            passYear: `${months[values.passMonth]}, ${values.passYear}`,
        };

        // Append all non-file fields
        // Object.entries(values).forEach(([key, value]) => {
        Object.entries(submitValues).forEach(([key, value]) => {
            // if (key === "files") return;
            if (key === "files" || key === "passMonth") return;
            if (key === "preferences") {
                const joinedPrefs = value.filter(Boolean).join(", ");
                formData.append(key, joinedPrefs);
            } else if (Array.isArray(value)) {
                value.forEach((v, i) => formData.append(`${key}[${i}]`, v));
            } else {
                formData.append(key, value);
            }
        });

        // Append files
        Object.entries(values.files).forEach(([key, file]) => {
            if (file) {
                formData.append(key, file);
            }
        });

        console.log("Submitting form values:", formData);
        try {
            const response = await axios.post("https://admissions.swec.ac.in/api/admission", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            alert("Form submitted successfully!");
            console.log(response.data);
            resetForm();
        } catch (error) {
            alert("Submission failed. Please try again.");
            console.error(error);
        }
    };


    return (
        <>
            <Navbar />
            <div className="graduate-admission   pb-70">
                <div className="container">
                    <div className=" card  p-2 p-lg-5 mt-5 mb-5">
                        <h2 className="mb-4 h4">B.Tech Admission Form (2026 - 2027) - Category-B (NRI/NRI Sponsored)</h2>


                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ setFieldValue, isSubmitting, errors, touched, submitCount }) => (
                                <Form>
                                    <h5>1. Personal Details</h5>
                                    <div className="row m-0 p-0">
                                        <div className="col-md-6 px-3">
                                            <div className="form-floating mb-3">
                                                <Field
                                                    id="name"
                                                    name="name"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Full Name as per SSC"
                                                />
                                                <label className="text-muted" htmlFor="name">
                                                    Full Name as per SSC <span className="text-danger">*</span>
                                                </label>
                                                <ErrorMessage name="name" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>

                                        {["dob", "fatherName", "motherName"].map((field) => (
                                            <div className="col-md-6 px-3" key={field}>
                                                <div className="form-floating mb-3">
                                                    <Field
                                                        id={field}
                                                        name={field}
                                                        type={field === "dob" ? "date" : "text"}
                                                        className="form-control"
                                                        placeholder={field}
                                                    />
                                                    <label className="text-muted" htmlFor={field}>
                                                        {field.replace(/([A-Z])/g, " $1").replace(/^\w/, c => c.toUpperCase())}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <ErrorMessage name={field} component="div" className="text-danger mt-1" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <h5 className="mt-3">2. Communication Address</h5>
                                    <div className="row m-0 p-0">
                                        {["address1", "address2", "city", "state", "zip"].map((field) => (
                                            <div className="col-md-6 px-3">
                                                <div className="form-floating mb-3" key={field}>
                                                    <Field
                                                        id={field}
                                                        name={field}
                                                        className="form-control"
                                                        placeholder={field}
                                                    />
                                                    <label className="text-muted" htmlFor={field}>{field.replace(/([A-Z])/g, ' $1').replace(/^\w/, c => c.toUpperCase())} <span className="text-danger">*</span></label>
                                                    <ErrorMessage name={field} component="div" className="text-danger mt-1" />
                                                </div>
                                            </div>
                                        ))}
                                        <div className="col-md-6 px-3">

                                            <div className="form-floating mb-3">
                                                <Field as="select" id="country" name="country" className="form-select">
                                                    <option value="India">India</option>
                                                    <option value="Other">Other</option>
                                                </Field>
                                                <label className="text-muted" htmlFor="country">Country <span className="text-danger">*</span></label>
                                                <ErrorMessage name="country" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>
                                    </div>


                                    <h5 className="mt-3">3. Contact Details</h5>
                                    <div className="row m-0 p-0">
                                        {["email", "confirmEmail"].map((field) => (
                                            <div className="col-md-6 px-3">
                                                <div className="form-floating mb-3" key={field}>
                                                    <Field
                                                        id={field}
                                                        name={field}
                                                        type="email"
                                                        className="form-control"
                                                        placeholder={field}
                                                    />
                                                    <label className="text-muted" htmlFor={field}>{field.replace(/([A-Z])/g, ' $1').replace(/^\w/, c => c.toUpperCase())} <span className="text-danger">*</span></label>
                                                    <ErrorMessage name={field} component="div" className="text-danger mt-1" />
                                                </div>
                                            </div>
                                        ))}
                                        <div className="col-md-6 px-3">
                                            <div className="form-floating mb-3">
                                                <Field id="aadhar" name="aadhar" className="form-control" placeholder="aadhar Number" />
                                                <label className="text-muted" htmlFor="aadhar">Aadhar Number <span className="text-danger">*</span></label>
                                                <ErrorMessage name="aadhar" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>

                                        <div className="col-md-6 px-3">
                                            <div className="form-floating mb-3">
                                                <Field id="mobile" name="mobile" className="form-control" placeholder="Mobile Number" />
                                                <label className="text-muted" htmlFor="mobile">Mobile Number <span className="text-danger">*</span></label>
                                                <ErrorMessage name="mobile" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>
                                    </div>

                                    <h5 className="mt-3">4. Academic Qualifications</h5>
                                    <div className="row m-0 p-0">
                                        <div className="col-md-6 px-3">
                                            <div className="form-floating mb-3">
                                                <Field
                                                    id="board"
                                                    name="board"
                                                    className="form-control"
                                                    placeholder="Name of the Board 10th + 2"
                                                />
                                                <label className="text-muted" htmlFor="board">
                                                    Name of the Board 10th + 2
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <ErrorMessage name="board" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3 row">
                                            <label className="form-label small mb-0">
                                                Month and Year of Passing <span className="text-danger">*</span>
                                            </label>

                                            <div className="col-md-6 px-3">
                                                <div className="mb-3">
                                                    <Field
                                                        as="select"
                                                        name="passMonth"
                                                        id="passMonth"
                                                        className="form-select"
                                                    >
                                                        <option value="">Select Month</option>
                                                        <option value="01">January</option>
                                                        <option value="02">February</option>
                                                        <option value="03">March</option>
                                                        <option value="04">April</option>
                                                        <option value="05">May</option>
                                                        <option value="06">June</option>
                                                        <option value="07">July</option>
                                                        <option value="08">August</option>
                                                        <option value="09">September</option>
                                                        <option value="10">October</option>
                                                        <option value="11">November</option>
                                                        <option value="12">December</option>
                                                    </Field>
                                                    <ErrorMessage name="passMonth" component="div" className="text-danger mt-1" />
                                                </div>
                                            </div>

                                            <div className="col-md-6 px-3">
                                                <div className="mb-3">
                                                    <Field
                                                        as="select"
                                                        name="passYear"
                                                        id="passYear"
                                                        className="form-select"
                                                    >
                                                        <option value="">Select Year</option>
                                                        {Array.from({ length: 20 }, (_, i) => {
                                                            const year = new Date().getFullYear() - i;
                                                            return (
                                                                <option key={year} value={year}>
                                                                    {year}
                                                                </option>
                                                            );
                                                        })}
                                                    </Field>
                                                    <ErrorMessage name="passYear" component="div" className="text-danger mt-1" />
                                                </div>
                                            </div>
                                        </div>

                                        {["totalMarks", "groupMarks"].map((field) => (
                                            <div className="col-md-6 px-3" key={field}>
                                                <div className="form-floating mb-3">
                                                    <Field
                                                        id={field}
                                                        name={field}
                                                        className="form-control"
                                                        placeholder={field}
                                                    />
                                                    <label className="text-muted" htmlFor={field}>
                                                        {field.replace(/([A-Z])/g, " $1").replace(/^\w/, c => c.toUpperCase())}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <ErrorMessage name={field} component="div" className="text-danger mt-1" />
                                                </div>
                                            </div>
                                        ))}

                                        <div className="col-md-6 px-3">
                                            <div className="mb-3">
                                                <label className="form-label">Qualifying Examination Passed <span className="text-danger">*</span></label>
                                                <div role="group" className="d-flex gap-3">
                                                    {["Intermediate", "CBSE", "ICSE", "Other"].map((val) => (
                                                        <label key={val} className="form-check-label text-muted">
                                                            <Field type="radio" name="qualifyingExam" value={val} className="form-check-input me-1" /> {val}
                                                        </label>
                                                    ))}
                                                </div>
                                                <ErrorMessage name="qualifyingExam" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>
                                    </div>

                                    <h5 className="mt-3">5. Course Preferences</h5>
                                    <div className="row m-0 p-0">
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <div className="col-md-6 px-3" key={`preferences[${i}]`}>
                                                <div className="form-floating mb-3">
                                                    <Field
                                                        as="select"
                                                        id={`preferences[${i}]`}
                                                        name={`preferences[${i}]`}
                                                        className="form-select text-muted"
                                                    >
                                                        <option value="" disabled hidden></option>

                                                        <option value="CSE">CSE</option>
                                                        <option value="CSE (AI & ML)">
                                                            CSE (AI & ML)
                                                        </option>
                                                        <option value="CSE (Data Science)">
                                                            CSE (Data Science)
                                                        </option>
                                                        <option value="ECE">ECE</option>
                                                        <option value="IT">IT</option>
                                                    </Field>
                                                    <label htmlFor={`preferences[${i}]`}>Preference {i + 1} <span className="text-danger">*</span></label>
                                                    <ErrorMessage name={`preferences[${i}]`} component="div" className="text-danger mt-1" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>


                                    <h5 className="mt-3">6. Sponsor Details</h5>
                                    <div className="row m-0 p-0">
                                        <div className="col-md-6 px-3">

                                            <div className="form-floating mb-3">
                                                <Field as="select" name="sponsorRelation" className="form-select" id="sponsorRelation">
                                                    <option value="">Select</option>
                                                    <option value="Parent">Parent</option>
                                                    <option value="Others">Others</option>
                                                </Field>
                                                <label className="text-muted" htmlFor="sponsorRelation">Relationship with Sponsor <span className="text-danger">*</span></label>
                                                <ErrorMessage name="sponsorRelation" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>

                                        <div className="col-md-6 px-3">
                                            <div className="form-floating mb-3">
                                                <Field
                                                    id="sponsorName"
                                                    name="sponsorName"
                                                    className="form-control"
                                                    placeholder="Sponsor Name"
                                                />
                                                <label className="text-muted" htmlFor="sponsorName">
                                                    Sponsor Name <span className="text-danger">*</span>
                                                </label>
                                                <ErrorMessage name="sponsorName" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>

                                        <div className="col-md-6 px-3">
                                            <div className="form-floating mb-3">
                                                <Field
                                                    id="sponsorPlace"
                                                    name="sponsorPlace"
                                                    className="form-control"
                                                    placeholder="Sponsor Place / Country"
                                                />
                                                <label className="text-muted" htmlFor="sponsorPlace">
                                                    Sponsor Place / Country <span className="text-danger">*</span>
                                                </label>
                                                <ErrorMessage name="sponsorPlace" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>

                                        <div className="col-md-6 px-3">
                                            <div className="form-floating mb-3">
                                                <Field
                                                    id="rank"
                                                    name="rank"
                                                    className="form-control"
                                                    placeholder="Rank in TG EAPCET"
                                                />
                                                <label className="text-muted" htmlFor="rank">
                                                    Rank in TG EAPCET <span className="text-danger">*</span>
                                                </label>
                                                <ErrorMessage name="rank" component="div" className="text-danger mt-1" />
                                            </div>
                                        </div>
                                    </div>

                                    <h5 className="mt-3">7. Document Uploads</h5>
                                    <div className="row m-0 p-0">
                                        {[
                                            { name: "photo", label: "Latest Passport Size Colour Photograph" },
                                            { name: "ssc", label: "10th Marks Memo (PDF only)" },
                                            { name: "inter", label: "Intermediate / 12th Marks Memo (PDF only)" },
                                            { name: "rankCard", label: "TG EAPCET 2026 Rank Card (optional)" },
                                            { name: "passport", label: "Passport / VISA of NRI" },
                                            { name: "sponsorLetter", label: "NRI Sponsorship Letter (PDF only)" },
                                            { name: "addressProof", label: "Address Proof / Driving License of NRI" },
                                            { name: "signature", label: "Scanned Signature of Applicant (JPG/JPEG)" },
                                            { name: "parentsignature", label: "Scanned Signature of Parent/Guardian (JPG/JPEG)" },
                                        ].map(({ name, label }) => {
                                            const isImage = name === "photo" || name === "signature" || name === "parentsignature";
                                            return (
                                                <div className="col-md-6 px-3 mb-4" key={name}>
                                                    <label htmlFor={name} className="form-label">
                                                        {label}
                                                    </label>
                                                    <div
                                                        className="dropzone border rounded drag-drop-area d-flex align-items-center justify-content-center text-center p-4"
                                                        onClick={() => document.getElementById(name).click()}
                                                        style={{ cursor: "pointer", backgroundColor: "#fafafa" }}
                                                    >
                                                        <div>
                                                            {fileNames[name] ? (
                                                                <>
                                                                    <p className="mb-1 fw-bold text-success">{fileNames[name]}</p>
                                                                    <p className="text-muted small mb-0">File selected</p>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <p className="mb-1 text-muted"><strong>Click or Drag & Drop file here</strong></p>
                                                                    <small className="text-muted small mb-0">{isImage ? "JPG, JPEG" : "PDF"} only, Max size: 300KB</small>
                                                                </>
                                                            )}
                                                        </div>
                                                        <input
                                                            id={name}
                                                            name={`files.${name}`}
                                                            type="file"
                                                            className="form-control d-none"
                                                            accept={isImage ? "image/jpeg,image/jpg" : "application/pdf"}
                                                            onChange={(event) => {
                                                                const file = event.currentTarget.files[0];
                                                                if (file && file.size > MAX_FILE_SIZE) {
                                                                    alert("File size should be less than 300KB.");
                                                                    event.target.value = ""; // Clear file input
                                                                    setFileNames((prev) => ({ ...prev, [name]: "" }));
                                                                    setFieldValue(`files.${name}`, null);
                                                                } else {
                                                                    setFieldValue(`files.${name}`, file);
                                                                    setFileNames((prev) => ({ ...prev, [name]: file?.name || "" }));
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <ErrorMessage name={`files.${name}`} component="div" className="text-danger mt-1" />
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div className="mt-4 border-top pt-4">
                                        <h5 className="mb-3">Declaration</h5>
                                        <div className="form-check mb-3">
                                            <Field
                                                type="checkbox"
                                                name="declaration"
                                                className="form-check-input"
                                                id="declaration"
                                            />
                                            <label className="form-check-label" htmlFor="declaration">
                                                We hereby declare that all the information furnished above is true to the best of our knowledge. We are aware and give you an undertaking that our application form can summarily be rejected if any information provided is wrong.
                                            </label>
                                            <ErrorMessage
                                                name="declaration"
                                                component="div"
                                                className="text-danger mt-1"
                                            />
                                        </div>
                                    </div>
                                    {submitCount > 0 && Object.keys(errors).length > 0 && (
                                        <div className="alert alert-danger">
                                            {Object.keys(errors).join(", ")} Required
                                        </div>
                                    )}
                                    <div className="mt-4 d-flex justify-content-center">
                                        <button type='submit' className="btn btn-primary bg-gradient ">
                                            {isSubmitting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" />
                                                    Submitting...
                                                </>
                                            ) : (
                                                <span>Submit</span>
                                            )}
                                        </button>
                                        <button type='reset' className="btn btn bg-danger bg-gradient ms-2 text-white">
                                            <span>Clear Form</span>
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BTechCategoryBFormNRI2026;
